function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { WDHComponent } from '../../../../../../../wdh-foundation/wdh';
import { spinner } from './views/Spinner';
import { EventTypes, TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import NavigationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/navigation-manager';
import AccountManagementAccordion from './account-management-accordion';
import AccountManagementDefaultAccount from "./account-management-default-account";
var EventBus = window.DGS.Event.getInstance();
var WdhAccountManagement = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @constructor
   * @augments WDHComponent
   * @param className
   * @inheritDoc
   */
  function WdhAccountManagement() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wdh-b2b-account-management-spot';
    _classCallCheck(this, WdhAccountManagement);
    return _callSuper(this, WdhAccountManagement, [className]);
  }
  _inherits(WdhAccountManagement, _WDHComponent);
  return _createClass(WdhAccountManagement, [{
    key: "init",
    value: function init(component) {
      var _this = this;
      ReactDOM.render(spinner, component.querySelector('.component-content'));
      window.shopInitReady === true ? this.checkAccess(component) : EventBus.on(EventTypes.SHOP_INIT_READY, function () {
        return _this.checkAccess(component);
      });
    }
  }, {
    key: "checkAccess",
    value: function checkAccess(component) {
      ReactDOM.render(/*#__PURE__*/React.createElement(AccountManagement, {
        className: this.className
      }), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
export default WdhAccountManagement;
var AccountManagement = /*#__PURE__*/function (_React$Component) {
  function AccountManagement(props) {
    var _this2;
    _classCallCheck(this, AccountManagement);
    _this2 = _callSuper(this, AccountManagement, [props]);
    _this2.translations = {
      accountManagementHeaderText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_HEADER_TEXT),
      accountManagementDescText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DESC_TEXT),
      accountManagementCommPreference: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_COMM_PREFERENCE),
      accountManagementUpdateNowText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_UPDATE_NOW_TEXT),
      accountManagementRequiredFieldText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_REQUIRED_FIELD_TEXT)
    };
    return _this2;
  }
  _inherits(AccountManagement, _React$Component);
  return _createClass(AccountManagement, [{
    key: "navigateToMyProfile",
    value: function navigateToMyProfile() {
      var url = '/myoticon/myaccount/edit-profile?tab="communicationPref"';
      NavigationManager.navigate(url);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, this.translations.accountManagementHeaderText), /*#__PURE__*/React.createElement(AccountManagementDefaultAccount, null), /*#__PURE__*/React.createElement("p", {
        className: "actMngDescText"
      }, this.translations.accountManagementDescText), /*#__PURE__*/React.createElement("p", {
        className: "actMngReqText"
      }, this.translations.accountManagementRequiredFieldText), /*#__PURE__*/React.createElement(AccountManagementAccordion, null), /*#__PURE__*/React.createElement("div", {
        className: "comm-block"
      }, /*#__PURE__*/React.createElement("p", null, this.translations.accountManagementCommPreference), /*#__PURE__*/React.createElement("button", {
        className: "wdh-feature-b2b-button dark-bg",
        onClick: function onClick(e) {
          e.preventDefault();
          _this3.navigateToMyProfile(e);
        }
      }, this.translations.accountManagementUpdateNowText)));
    }
  }]);
}(React.Component);